import { render } from "./RetrieveBookingForm.vue?vue&type=template&id=0b32666d"
import script from "./RetrieveBookingForm.vue?vue&type=script&lang=js"
export * from "./RetrieveBookingForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__